import logger from './logger'

const wxp = {
  /**
   * @function 获取系统信息
   */
  getSystemInfoSync () {
    return wx.getSystemInfoSync()
  },
  setNavigationBarColor (v) {
    return  wx.setNavigationBarColor(v)
  },
  getMenuButtonBoundingClientRect () {
    return  wx.getMenuButtonBoundingClientRect()
  },
  createSelectorQuery () {
    return  wx.createSelectorQuery()
  },
  /**
   * @function 设置导航栏标题
   */
  setNavigationBarTitle (title) {
    wx.setNavigationBarTitle({
      title,
      success (res) {
        logger.info({
          ThirdApiParam: title,
          ThirdApiSuccess: res,
          ThirdApi: 'wx.setNavigationBarTitle'
        }, 'OBJECT')
      },
      fail (err) {
        logger.info({
          ThirdApiParam: title,
          ThirdApiError: err,
          ThirdApi: 'wx.setNavigationBarTitle'
        }, 'OBJECT')
      }
    })
  },
  /**
   * @function toast提示
   */
  showToast (message: string) {
    wx.showToast({
      title: message,
      icon: 'none',
      duration: 2000
    })
  },
  /**
   * @function 显示加载
   */
  showLoading (loadingText: string) {
    wx.showLoading({
      title: loadingText,
      mask: true
    })
  },
  /**
   * @function 隐藏加载
   */
  hideLoading () {
    wx.hideLoading()
  },
  /**
   * @function 页面跳转
   */
  navigateTo (params) {
    return new Promise((resolve, reject) => {
      wx.navigateTo({
        ...params,
        success (res) {
          logger.info({
            ThirdApiParam: params,
            ThirdApiSuccess: res,
            ThirdApi: 'wx.navigateTo'
          }, 'OBJECT')
          resolve(res)
        },
        fail (err) {
          reject(err)
          logger.error({
            ThirdApiParam: params,
            ThirdApiError: err,
            ThirdApi: 'wx.navigateTo'
          }, 'OBJECT')
        }
      })
    })
  },
  /**
   * @function 页面重定向
   */
  redirectTo (params) {
    return new Promise((resolve, reject) => {
      wx.redirectTo({
        ...params,
        success (res) {
          resolve(res)
          logger.info({
            ThirdApiParam: params,
            ThirdApiSuccess: res,
            ThirdApi: 'wx.redirectTo'
          }, 'OBJECT')
        },
        fail (err) {
          reject(err)
          logger.error({
            ThirdApiParam: params,
            ThirdApiError: err,
            ThirdApi: 'wx.redirectTo'
          }, 'OBJECT')
        }
      })
    })
  },
  /**
   * @function 页面返回
   * @param object params
   */
  navigateBack (delta = 1) {
    let currentDelta = delta
    if (!delta || typeof delta !== 'number') {
      currentDelta = 1
    }
    return new Promise((resolve, reject) => {
      wx.navigateBack({
        delta: currentDelta,
        success (res) {
          resolve(res)
          logger.info({
            ThirdApiParam: `delta=${currentDelta}`,
            ThirdApiSuccess: res,
            ThirdApi: 'wx.navigateBack'
          }, 'OBJECT')
        },
        fail (err) {
          reject(err)
          logger.error({
            ThirdApiParam: `delta=${currentDelta}`,
            ThirdApiError: err,
            ThirdApi: 'wx.navigateBack'
          }, 'OBJECT')
        }
      })
    })
  },
  /**
   * @function 小程序跳转
   */
  navigateToMiniProgram (params) {
    return new Promise((resolve, reject) => {
      wx.navigateToMiniProgram({
        ...params,
        success: (res) => {
          resolve(res)
          logger.info({
            ThirdApiParam: params,
            ThirdApiSuccess: res,
            ThirdApi: 'wx.navigateToMiniProgram'
          }, 'OBJECT')
        },
        fail: (err) => {
          reject(err)
          logger.error({
            ThirdApiParam: params,
            ThirdApiError: err,
            ThirdApi: 'wx.navigateToMiniProgram'
          }, 'OBJECT')
        }
      })
    })
  },
  /**
   * @function 打开卡包
   */
  openCard (data) {
    return new Promise((resolve, reject) => {
      wx.openCard({
        ...data,
        success: (res) => {
          resolve(res)
          logger.info({
            ThirdApiParam: data,
            ThirdApiSuccess: res,
            ThirdApi: 'wx.openCard'
          }, 'OBJECT')
        },
        fail: (err) => {
          reject(err)
          logger.error({
            ThirdApiParam: data,
            ThirdApiError: err,
            ThirdApi: 'wx.openCard'
          }, 'OBJECT')
        }
      })
    })
  },
  /**
   * @function 微信支付接口
   * @param {*} params
   * @return {*}
 */  
  requestPayment (params) {
    return new Promise((resolve, reject) => {
      wx.requestPayment({
        ...params,
        success: function(res) {
          logger.info({
            ThirdApi: 'wx.requestPayment',
            ThirdApiParam: params,
            ThirdApiSuccess: res,
            Content: '调起微信支付接口success-成功'
          }, 'OBJECT')
          resolve(res)
        },
        fail: function(err) {
          logger.error({
            ThirdApi: 'wx.requestPayment',
            ThirdApiParam: params,
            ThirdApiError: err,
            Content: '调起微信支付接口fail-支付失败'
          }, 'OBJECT')
          reject(err)
        }
      })
    })
  },
  /**
   * @function 存储缓存
   * @author chendt
   * @param {String} key 键值
   * @param {Object} data 存储的值
   */
  setStorage (key, data) {
    let value = typeof data === 'object' ? JSON.stringify(data) : data
    try {
      wx.setStorageSync(key, value)
    } catch (e) {
      setTimeout(() => {
        wx.setStorageSync(key, value)
      }, 10)
    }
  },
  /**
   * @function 获取缓存、针对对象
   * @author chendt
   * @param {String} key 键值
   */
  getStorage (key) {
    try {
      const value = wx.getStorageSync(key)
      if (value) {
        return JSON.parse(value)
      }
    } catch (e) {
      setTimeout(() => {
        wxp.getStorage(key)
      }, 10)
    }
  }
}

export default wxp
